import Rails from "@rails/ujs"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  show(event) {
    $(event.currentTarget.dataset.selector).show()
  }

  reparse(event) {
    $(event.currentTarget.dataset.selector).show()
    event.currentTarget.closest('a').classList.add('disabled')
  }

}
